import { render, staticRenderFns } from "./AddDirectInStock.vue?vue&type=template&id=5fb095c9&scoped=true"
import script from "./AddDirectInStock.vue?vue&type=script&lang=js"
export * from "./AddDirectInStock.vue?vue&type=script&lang=js"
import style0 from "./AddDirectInStock.vue?vue&type=style&index=0&id=5fb095c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb095c9",
  null
  
)

export default component.exports